import _ from 'lodash'
import Backbone from 'backbone'
import template from './object-selector-form.hbs'
import FormView from 'scoreboard/components/form-view'
import ObjectSelector from 'scoreboard/components/object-selector'
import resizeDialogContent from 'scoreboard/components/resize-dialog-content'

var ObjectSelectorForm = Backbone.View.extend({

	tagName: 'form',

	className: 'object-selector-form',

	FormView,

	/**
	 * Initialize with the following options:
	 *
	 * @param {String} options.title a title to display in the header
	 *
	 * @param {String} [options.section]: the section of the type of object to be chosen in the selector
	 *
	 * @param {Number} [options.id] a default object to highlight in the selector
	 *
	 * @param {Number} [options.orgId] a default org to highlight in the selector
	 *
	 * @param {String} [options.banner] an HTML banner to display at the top of the page
	 *         CAREFUL!  Make sure you already have this escaped properly
	 *
	 * @param {String} [options.primaryButtonKey='common.done'] i18n code for
	 * the label of the primary button.  Defaults to "Done"
	 *
	 * @param {Function} [options.testSelectedObject] a function to test
	 * whether the selected domain object is valid. Return an error message if
	 * invalid, or a nil value if valid.
	 */
	initialize: function(options) {
		this.options = options || {}

		let DefaultFormView = this.FormView

		let FormViewConstructor
		if (this.options.testSelectedObject) {
			// If a testSelectedObject function was provided, we need to extend
			// the object selector's FormView to add testSelectedObject to
			// its test() method
			FormViewConstructor = DefaultFormView.extend({
				test: () => {
					let result = DefaultFormView.prototype.test.apply(this.formView)
					if (result) {
						return result
					}

					return this.options.testSelectedObject(this.objectSelector.selected())
				}
			})
		} else {
			FormViewConstructor = DefaultFormView
		}

		this.formView = new FormViewConstructor({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: () => !_.isNil(this.options.id)
		})

		this.formView.on('cancel', () => this.trigger('cancel'))

		this.objectSelector = new ObjectSelector(this.options)
		var change = this.formView.change.bind(this.formView)
		this.objectSelector.on('select', change)
		this.objectSelector.on('selectOrg', change)
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		this.$('.object-selector-container').append(this.objectSelector.el)
		this.objectSelector.render()

		this.formView.start()
		return this
	},

	context: function() {
		return _.defaults(this.options, {
			primaryButtonKey: 'common.done'
		})
	},

	reset: function() {
		this.formView.resetForm({skipDoneAnimation: true})
	},

	resize: function(maxHeight) {
		resizeDialogContent({
			dialog: this.el,
			maxHeight,
			target: this.$('.object-selector')
		})
		this.objectSelector.resize()
	},

	submit: function() {
		let selected = _.extend({},
			this.objectSelector.selected(),
			this.objectSelector.getSelectedState())

		this.trigger('select', selected, this.objectSelector.selectedOrg())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.objectSelector], 'remove')
	}

})

export default ObjectSelectorForm

ObjectSelectorForm.__filename__ = 'components/object-selector-form.js'
